import { render, staticRenderFns } from "./InstaGalleryButton.vue?vue&type=template&id=7b580680&scoped=true&"
import script from "./InstaGalleryButton.vue?vue&type=script&lang=js&"
export * from "./InstaGalleryButton.vue?vue&type=script&lang=js&"
import style0 from "./InstaGalleryButton.vue?vue&type=style&index=0&id=7b580680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b580680",
  null
  
)

export default component.exports